import { IHotelOwner } from '../../types/entities/IHotelOwner';
import {
    AccountInformationState,
    ContactState,
} from '../../types/profile/profileTypes';
import { isMinValueDate } from '../../utils/formatDates';
import { isAdded, isChanged } from '../../utils/collectionPersistence';

export const adaptAccountInformationDDBBToState = (
    accountInformation: IHotelOwner
): AccountInformationState => {
    return {
        Id: accountInformation.Id,
        Name: accountInformation.Name,
        Email: accountInformation.Email,
        ContactPerson: accountInformation.ContactPerson,
        Phone: accountInformation.Phone,
        IdOwnerType: accountInformation.IdOwnerType || 0,
        OwnerType:
            accountInformation.OwnerType?.LocalizedCaption ||
            accountInformation.OwnerType?.Caption ||
            accountInformation.OwnerType?.Name ||
            '',
        OwnerTypes: accountInformation.OwnerTypes,
        IdCountry: accountInformation.IdCountry,
        Country:
            accountInformation.Country?.LocalizedCaption ||
            accountInformation.Country?.Caption ||
            accountInformation.Country?.Name ||
            '',
        CountryCode: accountInformation.Country?.ISO2 || '',
        DateSigned: isMinValueDate(accountInformation.DateSigned)
            ? null
            : accountInformation.DateSigned,
        HotelChain: accountInformation.HotelChain?.Name || '',
        IdCurrency: accountInformation.IdCurrency || 0,
        Currency: accountInformation.Currency?.Name || '',
        Contacts:
            accountInformation.Contacts?.map(contact => ({
                Id: contact.Id,
                ContactType: contact.Source || '',
                EntityId: contact.EntityId,
                EntityName: contact.EntityName,
                Name: contact.Name,
                Email: contact.Email,
                Phone: contact.Phone || '',
                Position: contact.Position || '',
                ResponseTime: contact.ResponseTime || '',
                Notes: contact.Notes || '',
            })) || [],
    };
};

export const adaptAccountInformationStateToDDBB = (
    state: AccountInformationState
) => {
    return {
        Id: state.Id,
        Name: state.Name,
        Email: state.Email,
        ContactPerson: state.ContactPerson,
        Phone: state.Phone,
        IdOwnerType: state.IdOwnerType,
        OwnerTypes: state.OwnerTypes.map(ownerType => ({
            Id: ownerType.Id,
            Name: ownerType.Name,
            __isAdded: ownerType.__isAdded,
            __isChanged: ownerType.__isChanged,
            Deleted: ownerType.Deleted,
        })),
        IdCountry: state.IdCountry,
        IdCurrency: state.IdCurrency,
    };
};

/**
 * Adapts a single contact for an owner save, normalizing addition flags.
 * @param idOwner Owner receiving the contact update.
 * @param contact Contact detail to persist.
 * @returns Owner payload containing only the supplied contact.
 */
export const adaptAccountContactsStateToDDBB = (
    idOwner: string,
    contact: ContactState
) => {
    return {
        Id: idOwner,
        Contacts: [
            {
                Id: contact.Id,
                Source: contact.ContactType || '',
                EntityId: parseInt(idOwner),
                EntityName: 'HotelOwner',
                Name: contact.Name,
                Email: contact.Email,
                Phone: contact.Phone || '',
                Position: contact.Position || '',
                ResponseTime: contact.ResponseTime || '',
                Notes: contact.Notes || '',
                __isAdded: isAdded(contact),
                __isChanged: isAdded(contact) || isChanged(contact),
                Deleted: contact.Deleted,
            },
        ],
    };
};
